import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-head" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-brand"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["aria-label", "data-tooltip"]
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_8 = {
  key: 1,
  class: "nav-kbd"
}
const _hoisted_9 = { class: "nav-icon" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_12 = ["aria-expanded", "aria-label", "onClick"]
const _hoisted_13 = { class: "nav-icon" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_16 = {
  key: 1,
  class: "nav-chevron",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = {
  key: 0,
  class: "nav-flyout-title"
}
const _hoisted_18 = {
  key: 0,
  class: "nav-sub-heading"
}
const _hoisted_19 = { class: "nav-icon" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "nav-label" }
const _hoisted_22 = {
  key: 1,
  class: "nav-external",
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_23 = { class: "sidebar-shortcuts" }
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_26 = {
  key: 1,
  class: "nav-kbd"
}
const _hoisted_27 = {
  key: 0,
  class: "sidebar-footer"
}
const _hoisted_28 = {
  key: 0,
  class: "nav-label"
}

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { usePermission } from '@/composables/usePermission'
import { openGlobalSearch } from '@/composables/useGlobalSearch'
import { toggleShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useLogo } from '@/composables/useLogo'
import { useStore } from 'vuex'
import { aiMenuCounts, loadAiMenuCounts, type AiMenuCountKey } from '@/composables/useAiMenuCounts'

interface NavItem {
  to: string; label: string; perm?: string; icon: string; exact?: boolean; className?: string
  /** Subtítulo mostrado antes do item, dentro do grupo. */
  heading?: string
  /** Contador ao lado (alert = vermelho quando > 0). */
  count?: { key: AiMenuCountKey; alert?: boolean }
  /** Atalho pra outra tela (ícone de seta, nunca fica marcado como ativo). */
  shortcut?: boolean
}
interface NavGroup { key: string; label: string; icon: string; items: NavItem[] }

const STORAGE_KEY = 'sidebar_open_groups'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    collapsed: { type: Boolean }
  },
  emits: ["update:collapsed"],
  setup(__props: any, { emit: __emit }) {

const { logoUrl } = useLogo()

const props = __props

const emit = __emit

const route   = useRoute()
const { can } = usePermission()

const ICONS = {
  dashboard: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
  foco: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><line x1="12" y1="1" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="23"/><line x1="1" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="23" y2="12"/>',
  chat: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
  headset: '<path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>',
  chart: '<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
  people: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
  resumo: '<rect x="2" y="3" width="5" height="5" rx="1"/><rect x="9" y="3" width="5" height="5" rx="1"/><rect x="16" y="3" width="6" height="5" rx="1"/><rect x="2" y="11" width="5" height="10" rx="1"/><rect x="9" y="11" width="5" height="6" rx="1"/><rect x="16" y="11" width="6" height="8" rx="1"/>',
  check: '<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>',
  clock: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  bolt: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
  flow: '<rect x="3" y="3" width="7" height="6" rx="1"/><rect x="14" y="15" width="7" height="6" rx="1"/><path d="M6.5 9v3a2 2 0 0 0 2 2h7a2 2 0 0 1 2 2v-1"/>',
  star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  cpu: '<rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/>',
  list: '<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>',
  agent: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0-3-3.87"/>',
  tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
  robot: '<rect x="4" y="7" width="16" height="12" rx="3"/><path d="M12 3v4"/><circle cx="12" cy="3" r="1"/><circle cx="9" cy="13" r="1.2"/><circle cx="15" cy="13" r="1.2"/><path d="M9.5 16.5h5"/>',
  book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>',
  upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>',
  bulb: '<path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z"/>',
  help: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  alert: '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
}

const TOP_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: ICONS.dashboard, exact: true },
  { to: '/foco', label: 'Modo Foco', perm: 'foco.view', icon: ICONS.foco },
]

const GROUPS: NavGroup[] = [
  {
    key: 'atendimento', label: 'Atendimento', icon: ICONS.headset, items: [
      { to: '/fila', label: 'Fila', perm: 'fila.view', icon: ICONS.list },
      { to: '/contacts', label: 'Contatos', perm: 'contacts.view', icon: ICONS.people },
      { to: '/templates', label: 'Templates WA', perm: 'templates.view', icon: ICONS.chat },
      { to: '/macros', label: 'Macros', perm: 'macros.view', icon: ICONS.bolt },
      { to: '/fluxos-bot', label: 'Fluxos de bot', perm: 'bot.view', icon: ICONS.flow },
      { to: '/ciclos', label: 'Ciclos de envio', perm: 'ciclos.view', icon: ICONS.clock },
    ],
  },
  {
    key: 'relatorios', label: 'Relatórios', icon: ICONS.chart, items: [
      { to: '/resumo', label: 'Resumo', perm: 'resumo.view', icon: ICONS.resumo },
      { to: '/metricas', label: 'Métricas', perm: 'metricas.view', icon: ICONS.chart },
      { to: '/relatorios', label: 'Relatórios da operação', perm: 'relatorios.view', icon: ICONS.list },
      { to: '/relatorio-resolucao', label: 'Relatório de Resolução', perm: 'relatorioResolucao.view', icon: ICONS.check },
      { to: '/sla', label: 'SLA', perm: 'sla.view', icon: ICONS.clock },
      { to: '/avaliacoes', label: 'Avaliações', perm: 'avaliacoes.view', icon: ICONS.star },
      { to: '/sla-metro', label: 'SLA Telão', perm: 'slaMetro.view', icon: ICONS.alert, className: 'nav-item--metro' },
    ],
  },
  {
    key: 'gestao', label: 'Gestão', icon: ICONS.settings, items: [
      { to: '/agentes', label: 'Agentes', perm: 'agentes.view', icon: ICONS.agent },
      { to: '/teams', label: 'Times', perm: 'teams.view', icon: ICONS.people },
      { to: '/etiquetas', label: 'Etiquetas', perm: 'etiquetas.view', icon: ICONS.tag },
      { to: '/consumo', label: 'Consumo do servidor', perm: 'monitoring.view', icon: ICONS.cpu },
    ],
  },
  {
    // Inteligência Artificial: a tela que ficava no Admin, agora em /ia/<página>, com os submenus como subtítulos.
    key: 'ia', label: 'Inteligência Artificial', icon: ICONS.robot, items: [
      { to: '/ia/agentes', label: 'Agentes de IA', perm: 'ai.view', icon: ICONS.robot, count: { key: 'agents' } },
      { to: '/ia/documentos', label: 'Documentos', perm: 'ai.view', icon: ICONS.book, heading: 'Base de conhecimento', count: { key: 'documents' } },
      { to: '/ia/importar-pdf', label: 'Importar PDF', perm: 'ai.edit', icon: ICONS.upload },
      { to: '/ia/conversas', label: 'Conversas', perm: 'ai.view', icon: ICONS.chat, heading: 'Aprendizado' },
      { to: '/ia/sugestoes', label: 'Sugestões', perm: 'ai.view', icon: ICONS.bulb, count: { key: 'suggestions', alert: true } },
      { to: '/ia/duvidas-frequentes', label: 'Dúvidas frequentes', perm: 'ai.mark', icon: ICONS.help, count: { key: 'faq', alert: true } },
      { to: '/ia/o-que-sabe', label: 'O que o agente já sabe', perm: 'ai.view', icon: ICONS.check, heading: 'Conferência' },
      { to: '/admin?abrir=vertex', label: 'Vertex AI', perm: 'settings.manage', icon: ICONS.settings, heading: 'Atalhos', shortcut: true },
      { to: '/relatorios?r=ia', label: 'Consumo de IA', perm: 'relatorios.view', icon: ICONS.chart, shortcut: true },
    ],
  },
]

const allowed = (i: NavItem) => !i.perm || can(i.perm)
const topItems = computed(() => TOP_ITEMS.filter(allowed))
// Grupo sem nenhum item permitido some inteiro.
const visibleGroups = computed(() =>
  GROUPS.map(g => ({ ...g, visibleItems: g.items.filter(allowed) })).filter(g => g.visibleItems.length > 0))

const inRoute = (to: string) => route.path === to || route.path.startsWith(`${to}/`)
const groupActive = (g: NavGroup) => g.items.some(i => inRoute(i.to))

// Grupos abertos ficam salvos (só conveniência por navegador — se o storage falhar, todos começam fechados).
function readOpen(): string[] {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') } catch { return [] }
}
const openGroups = ref<string[]>(readOpen())
watch(openGroups, v => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)) } catch { /* sem storage */ } }, { deep: true })

const isOpen = (key: string) => openGroups.value.includes(key)

function toggleGroup(key: string) {
  // Recolhido: o clique abre o menu já com o grupo expandido (o painel flutuante é só no hover).
  if (props.collapsed) {
    if (!isOpen(key)) openGroups.value = [...openGroups.value, key]
    emit('update:collapsed', false)
    return
  }
  openGroups.value = isOpen(key) ? openGroups.value.filter(k => k !== key) : [...openGroups.value, key]
}

// Contadores da IA: carregam ao abrir o app e de novo a cada entrada numa página /ia (a tela também recarrega ao salvar).
const store = useStore()
watch(() => route.path.startsWith('/ia/'), (inIa, wasIa) => {
  if (!can('ai.view') || (wasIa !== undefined && !inIa)) return
  loadAiMenuCounts(store.getters.authUser?.wootdash_token ?? '', can('ai.mark'))
}, { immediate: true })

// Página atual dentro de um grupo fechado: abre ele, pra o item ativo ficar visível.
watch(() => route.path, () => {
  const g = GROUPS.find(groupActive)
  if (g && !isOpen(g.key)) openGroups.value = [...openGroups.value, g.key]
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["sidebar", { 'sidebar--collapsed': __props.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(logoUrl),
              alt: "ISBET",
              class: "sidebar-brand-img"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "sidebar-toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:collapsed', !__props.collapsed))),
        "aria-label": __props.collapsed ? 'Expandir menu' : 'Recolher menu',
        "data-tooltip": __props.collapsed ? 'Expandir menu' : 'Recolher menu'
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("line", {
            x1: "3",
            y1: "6",
            x2: "21",
            y2: "6"
          }),
          _createElementVNode("line", {
            x1: "3",
            y1: "12",
            x2: "21",
            y2: "12"
          }),
          _createElementVNode("line", {
            x1: "3",
            y1: "18",
            x2: "21",
            y2: "18"
          })
        ], -1)
      ]))], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "nav-item nav-item--search",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openGlobalSearch) && _unref(openGlobalSearch)(...args))),
        "aria-label": __props.collapsed ? 'Buscar (Ctrl+K)' : undefined,
        "data-tooltip": "Buscar · Ctrl+K"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "8"
            }),
            _createElementVNode("line", {
              x1: "21",
              y1: "21",
              x2: "16.65",
              y2: "16.65"
            })
          ])
        ], -1)),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Buscar"))
          : _createCommentVNode("", true),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("kbd", _hoisted_8, "Ctrl K"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_6),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topItems.value, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.to,
          to: item.to,
          class: "nav-item",
          "exact-active-class": item.exact ? 'nav-item--active' : undefined,
          "active-class": item.exact ? undefined : 'nav-item--active',
          "aria-label": __props.collapsed ? item.label : undefined,
          "data-tooltip": item.label
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, [
              (_openBlock(), _createElementBlock("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                innerHTML: item.icon
              }, null, 8, _hoisted_10))
            ]),
            (!__props.collapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.label), 1))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["to", "exact-active-class", "active-class", "aria-label", "data-tooltip"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleGroups.value, (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.key,
          class: _normalizeClass(["nav-group", { 'nav-group--open': isOpen(group.key), 'nav-group--active': groupActive(group) }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "nav-item nav-group-head",
            "aria-expanded": isOpen(group.key),
            "aria-label": __props.collapsed ? group.label : undefined,
            onClick: ($event: any) => (toggleGroup(group.key))
          }, [
            _createElementVNode("span", _hoisted_13, [
              (_openBlock(), _createElementBlock("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                innerHTML: group.icon
              }, null, 8, _hoisted_14))
            ]),
            (!__props.collapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(group.label), 1))
              : _createCommentVNode("", true),
            (!__props.collapsed)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_12),
          (__props.collapsed || isOpen(group.key))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["nav-sub", { 'nav-sub--flyout': __props.collapsed }])
              }, [
                (__props.collapsed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(group.label), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.visibleItems, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.to
                  }, [
                    (item.heading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.heading), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: item.to,
                      class: _normalizeClass(["nav-item nav-subitem", item.className]),
                      "active-class": item.shortcut ? '' : 'nav-item--active',
                      "exact-active-class": item.shortcut ? '' : undefined
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_19, [
                          (_openBlock(), _createElementBlock("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            innerHTML: item.icon
                          }, null, 8, _hoisted_20))
                        ]),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.label), 1),
                        (item.count && _unref(aiMenuCounts)[item.count.key] !== null)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["nav-count", { 'nav-count--alert': item.count.alert && (_unref(aiMenuCounts)[item.count.key] ?? 0) > 0 }])
                            }, _toDisplayString(_unref(aiMenuCounts)[item.count.key]), 3))
                          : _createCommentVNode("", true),
                        (item.shortcut)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }, null, -1),
                              _createElementVNode("polyline", { points: "15 3 21 3 21 9" }, null, -1),
                              _createElementVNode("line", {
                                x1: "10",
                                y1: "14",
                                x2: "21",
                                y2: "3"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to", "class", "active-class", "exact-active-class"])
                  ], 64))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("button", {
        class: "nav-item nav-item--shortcuts",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleShortcutsHelp) && _unref(toggleShortcutsHelp)(...args))),
        "aria-label": __props.collapsed ? 'Atalhos de teclado (?)' : undefined,
        "data-tooltip": "Atalhos de teclado · ?"
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "nav-icon nav-icon--shortcuts" }, "?", -1)),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Atalhos"))
          : _createCommentVNode("", true),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("kbd", _hoisted_26, "?"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_24)
    ]),
    (_unref(can)('admin.view'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_router_link, {
            to: "/admin",
            class: "nav-item nav-item--admin",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Admin' : undefined,
            "data-tooltip": "Admin"
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Admin"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})